import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ENROLLED_USER_SESSION } from 'src/app/@constants/local-storage-key-constants';
import {
  EventEnrollSessionUser,
  EventEnrollUserRequestData,
  EventEnrollUserSessionResponse,
  EventEnrollUserSessionResponseData,
} from 'src/app/@data-services/event-enroll/event-enroll.data-model';
import { EventEnrollDataService } from 'src/app/@data-services/event-enroll/event-enroll.data-service';
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from 'src/app/@utils/local-storage-util';

@Injectable({
  providedIn: 'root',
})
export class UserEnrollSessionService {
  private readonly _eventEnrollDataService = inject(EventEnrollDataService);

  ensureValidEnrolledUserSession(
    user: EventEnrollSessionUser
  ): Observable<EventEnrollUserSessionResponseData | boolean> {
    if (!this._isUserSessionExpired()) {
      return of(false);
    }

    const requestData: EventEnrollUserRequestData = {
      action: 'createSession',
      eventNameIdentifier: user.eventNameIdentifier,
      userIdentifier: user.userIdentifier,
      sentFrom: 'insights',
    };

    return this._eventEnrollDataService
      .createEnrolledUserSession(requestData)
      .pipe(
        tap((response: EventEnrollUserSessionResponseData) => {
          if (response.data?.sessionID) {
            const sessionData: EventEnrollUserSessionResponse = {
              sessionID: response.data.sessionID,
              expiration: response.data.expiration,
            };
            setLocalStorageItem(ENROLLED_USER_SESSION, sessionData);
          }
        })
      );
  }

  private _isUserSessionExpired(): boolean {
    const session = getLocalStorageItem<EventEnrollUserSessionResponse>(
      ENROLLED_USER_SESSION
    );
    if (!session) return true;

    const currentTimestamp = Math.floor(Date.now() / 1000);
    return currentTimestamp > session.expiration;
  }
}
